import React from "react";
import { Spin } from "antd";

const Loader = ({ loading, text = "Loading..." }) => {
  return loading ? (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10,
      }}
    >
      <Spin size="large" />
    </div>
  ) : null;
};

export default Loader;
